import {validateNumber} from '@/validate';
import {FormValues} from '@/accounts/form/types';

export const validateAccount = ({connectionLimit}: FormValues) => {
  const errors = {} as any;

  if (connectionLimit) {
    errors.connectionLimit = validateNumber(connectionLimit);
  }

  return errors;
};
